{
  "electronicJournalResource": "/store/retail_transactions/v1",
  "storePrintersResource": "/store/printers/v1",
  "authResource": "/buy/auth/v1",
  "oktaAegisHost": "https://api.aegis.nikecloud.com",
  "oktaClientID": "nike.rcf.electronicjournal",
  "receiptsResource": "/buy/retail_receipts/v1",
  "storeviewsResource": "/store/store_views/v2",
  "eventCapturedResource": "/store/catch_event/v1",
  "fetchReceiptResource": "/store/receipt/v1",
  "reprintEventResource": "/store/reprint_event/v1"
}
